import React from 'react';
import clsx from 'clsx';
import { Image, T } from '@colonist/ui';
import styles from './PlayerInformation.module.scss';
/** Profile header showing avatar, membership badge, and username. */ export const PlayerInformation = ({ username, playerIcon, usernameSize, membershipIcon, playerKarma, onClick })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.playerInformation, onClick != undefined && styles.clickable),
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.iconWrapper
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.icon,
        image: {
            src: playerIcon,
            alt: 'strings:imgAlts.PlayerIcon'
        }
    }), membershipIcon != undefined && /*#__PURE__*/ React.createElement(Image, {
        className: styles.membershipIcon,
        image: {
            src: membershipIcon,
            alt: 'strings:imgAlts.MembershipIcon'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.textContainer
    }, /*#__PURE__*/ React.createElement("h1", {
        className: clsx(styles.username, styles[usernameSize])
    }, username), playerKarma != undefined && /*#__PURE__*/ React.createElement("p", {
        className: styles.karma
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:homePage.header.playerKarma",
        options: {
            totalCompleted: playerKarma.karma,
            totalGames: playerKarma.karmaCompletedGameCount
        }
    }))));
